import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgTicketEvent = function SvgTicketEvent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "m9.2 16 2.8-2.1 2.75 2.1-1.05-3.4 2.8-2.2h-3.4L12 7l-1.1 3.4H7.5l2.75 2.2zM4 20q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18v-3.375q0-.275.175-.475a.76.76 0 0 1 .45-.25q.6-.2.987-.725A1.93 1.93 0 0 0 4 12q0-.65-.388-1.175a2 2 0 0 0-.987-.725.76.76 0 0 1-.45-.25A.7.7 0 0 1 2 9.375V6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4h16q.824 0 1.413.588Q22 5.175 22 6v3.375a.7.7 0 0 1-.175.475.76.76 0 0 1-.45.25q-.6.2-.988.725Q20 11.35 20 12t.387 1.175.988.725a.76.76 0 0 1 .45.25.7.7 0 0 1 .175.475V18q0 .824-.587 1.413A1.93 1.93 0 0 1 20 20zm0-2h16v-2.55a4.1 4.1 0 0 1-1.462-1.462A3.85 3.85 0 0 1 18 12q0-1.076.538-1.988A4.1 4.1 0 0 1 20 8.55V6H4v2.55a4.1 4.1 0 0 1 1.463 1.462Q6 10.926 6 12q0 1.076-.537 1.988A4.1 4.1 0 0 1 4 15.45z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTicketEvent);

export { ForwardRef as default };
